<template>
  <div class="table-responsive mt-3" style="overflow: auto; padding-bottom: 30px; max-height: 70vh">
    <table class="table" style="text-align: center; width: 2000px">
      <thead>
      <tr style="border: 1px solid #EBEDF3">
        <th scope="col" class="w-60px header-table">STT</th>
        <th scope="col" class="w-100px header-table">Mã nhân sự</th>
        <th scope="col" class="min-w-100px header-table">Vị trí</th>
        <th scope="col" class="min-w-80px header-table">Bộ phận / khu vực</th>
        <th scope="col" class="min-w-80px header-table">Chức danh</th>
        <th scope="col" class="min-w-80px header-table">Hình thức</th>
        <th scope="col" class="w-80px header-table">Level chuyên môn</th>
        <th scope="col" class="w-80px header-table">Level quản trị</th>
        <th scope="col" class="w-80px header-table">Mốc thời gian</th>
        <th scope="col" class="w-100px header-table">Nhóm phòng ban</th>
        <th scope="col" class="w-100px header-table">Nhóm ban vùng</th>
        <th scope="col" class="w-80px header-table">Thâm liên làm việc</th>
        <th scope="col" class="w-80px header-table">Thâm liên tại vị trí</th>
        <th scope="col" class="min-w-100px header-table">Lỗi</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item of responseError" :key="item?.index" style="border: 1px solid #EBEDF3; border-top: 0">
        <td>{{item?.index}}</td>
        <td style="text-align: start; text-transform: uppercase">{{item?.ma_nhan_su}}</td>
        <td style="text-align: start">{{item?.vi_tri}}</td>
        <td style="text-align: start">{{item?.bo_phan_khu_vuc }}</td>
        <td style="display: flex; justify-content: start; border-top: 0 !important; word-break: break-word; text-align: start">{{item?.chuc_danh}}</td>
        <td style="text-align: start; word-break: break-word">{{item?.hinh_thuc}}</td>
        <td style="text-align: start">{{item?.level_chuyen_mon}}</td>
        <td style="text-align: start; word-break: break-word">{{item?.level_quan_tri}}</td>
        <td style="text-align: start; word-break: break-word">{{item?.moc_thoi_gian}}</td>
        <td style="text-align: start; word-break: break-word">{{item?.nhom_van_phong }}</td>
        <td style="text-align: start; word-break: break-word">{{item?.phong_ban_vung }}</td>
        <td style="text-align: start; word-break: break-word">{{item?.tham_nien_lam_viec }}</td>
        <td style="text-align: start; word-break: break-word">{{item?.tham_nien_tai_vi_tri }}</td>
        <td>
            <div v-if="item.error.length > 0" style="text-align: start; display: flex; flex-direction: column">
              <span class="text-danger" v-for="(e, index) in item.error" :key="index + e" style="word-break: break-word">
                {{e}}
              </span>
            </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'TableErrorHistoryUser',
  data() {
    return {}
  },
  props: {
    responseError: {
      type: Object,
      default: {}
    }
  }
}
</script>

<style lang="css" scoped>
  .header-table {
    background: #F8F8F8;
    text-align: start;
    word-break: break-word;
  }
</style>